import {AuthService} from "@auth/auth.service";
import {filter, firstValueFrom} from "rxjs";
import {
  OAuthModuleConfig,
  OAuthResourceServerErrorHandler,
  OAuthService
} from "angular-oauth2-oidc";
import { HttpInterceptor } from "@angular/common/http";
import {environment} from "@environments/environment";
import {TokenAuthInterceptor} from "@auth/token-auth.interceptor";

export function initLogin(authService: AuthService): () => Promise<boolean> {
  return (): Promise<boolean> => {
    const targetUrl = globalThis.location.pathname + globalThis.location.search + globalThis.location.hash;
    return firstValueFrom(
      authService
        .login(targetUrl === '/' ? undefined : targetUrl)
        // prevent application starting before authentication is done
        .pipe(filter((loggedIn) => loggedIn))
    );
  };
}

export function authHttpInterceptor(
  oAuthService: OAuthService,
  errorHandler: OAuthResourceServerErrorHandler,
  moduleConfig: OAuthModuleConfig
): HttpInterceptor {
  return new TokenAuthInterceptor(
    oAuthService,
    errorHandler,
    moduleConfig,
    environment.sso.tokenType !== "access_token"
  );
}
